import React from 'react';
import { connect } from 'react-redux';
import TextBlockBodyContainer from './text-block-body-container';
import { setTextBlockBodyTitle, setTextBlockBodyText } from '../../../../state/actions/landing-page-editor';

const TextBlockBodyRedux = (props) => (
  <TextBlockBodyContainer {...props} />
);

const mapStateToProps = (state, ownProps) => {
  const { entityId:id } = ownProps;
  const { editor } = state.landingPages.landingPage;
  const currentEntity = editor[id] || {};
  const tbb = currentEntity.textBlockBody || { title: '', text: '' };
  return {
    title: tbb.title,
    text: tbb.text,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const { entityId:id } = ownProps;
  return {
    onTitleChange: (val) => dispatch(setTextBlockBodyTitle(id, val)),
    onTextChange: (val) => dispatch(setTextBlockBodyText(id, val)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TextBlockBodyRedux);


